import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Pencil01 = function Pencil01(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M4.2668 13.5777c.113-.2938.1695-.4407.2433-.5782a2.4892 2.4892 0 0 1 .2261-.3479c.0956-.1232.207-.2345.4295-.4571l9.3374-9.3374c.9143-.9143 2.3968-.9143 3.3111 0 .9144.9144.9144 2.3969 0 3.3112l-9.3373 9.3373c-.2226.2226-.3339.3339-.4571.4296a2.4843 2.4843 0 0 1-.348.2261c-.1374.0738-.2843.1303-.5781.2433L2.5 18.1714l1.7668-4.5937Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M4.2037 13.7418c.122-.317.1829-.4755.2874-.5481a.4139.4139 0 0 1 .3137-.0665c.125.0238.2451.1439.4853.3841l1.87 1.87c.2402.2402.3602.3602.3841.4853a.414.414 0 0 1-.0666.3137c-.0725.1045-.231.1655-.548.2874L2.5 18.1714l1.7037-4.4296Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m2.5 18.1714 4.5937-1.7668c.2938-.113.4407-.1695.5781-.2433a2.4843 2.4843 0 0 0 .348-.2261c.1232-.0957.2345-.207.4571-.4296l9.3373-9.3373c.9144-.9143.9144-2.3968 0-3.3112-.9143-.9143-2.3968-.9143-3.3111 0l-9.3374 9.3374c-.2226.2226-.3339.3339-.4295.4571a2.4901 2.4901 0 0 0-.2261.3479c-.0738.1375-.1303.2844-.2433.5782L2.5 18.1714Zm0 0 1.7037-4.4296c.122-.317.1829-.4755.2874-.5481a.4139.4139 0 0 1 .3137-.0665c.125.0238.2451.1439.4853.3841l1.87 1.87c.2402.2402.3602.3602.3841.4853a.414.414 0 0 1-.0666.3137c-.0725.1045-.231.1655-.548.2874L2.5 18.1714Z"
    })]
  }));
};
export default Pencil01;